// @ts-check

import { LEARNING_MODE } from 'Context/ClassroomContext';

/**
 * @param {SectionGroup[]} sectionGroups
 * @param {LearningMode} learningMode
 * @returns {SectionGroup[]}
 */
export function getLearningModeSectionGroups(sectionGroups, learningMode) {
  if (learningMode === 'DEFAULT') return sectionGroups;

  const filterSectionGroup = [];

  for (const sectionGroup of sectionGroups) {
    const sections = sectionGroup.sections;

    if (sections.length > 0) {
      filterSectionGroup.push({ ...sectionGroup, sections });
    }
  }

  return filterSectionGroup;
}

// TODO: [LAMS-923] edit when have multiple learning mode
/**
 * @param {Section[]} sections
 * @param {LearningMode} learningMode
 * @returns {Section[]}
 */
export function getLearningModeSections(sections, learningMode) {
  if (learningMode === 'DEFAULT') return sections;

  const filteredSections = [];
  for (const section of sections) {
    const subSections = section.subSections.filter(
      ({ learningModes }) => learningModes && learningModes.includes('FOCUS')
    );

    if (subSections.length > 0) {
      filteredSections.push({ ...section, subSections });
    }
  }
  return filteredSections;
}

/**
 * @template {Subsection} T
 *
 * @param {T[]} subsections
 * @param {LearningMode} learningMode
 * @returns {T[]}
 */
export function getLearningModeSubsections(subsections, learningMode) {
  if (learningMode === 'DEFAULT') return subsections;

  const filteredSubsections = subsections.filter(
    ({ learningModes }) => learningModes && learningModes.includes('FOCUS')
  );
  return filteredSubsections;
}

/**
 * @template {Subsection} T
 *
 * @param {T[]} subsections
 * @param {string} learningMode
 * @returns {T[]}
 */
export function getSubsectionInMode(subsections, learningMode) {
  if (learningMode === LEARNING_MODE.DEFAULT) return subsections;

  const filteredSubsections = subsections.filter(
    ({ learningModes }) => learningModes && learningModes.includes(learningMode)
  );

  return filteredSubsections;
}

/**
 * @param {Subsection[]=} subsections
 * @returns {boolean}
 */
export function isSubsectionsHasLearningMode(subsections = []) {
  for (const subsection of subsections) {
    const notDefaultLearningModes = subsection.learningModes?.filter(
      (learningMode) => learningMode !== LEARNING_MODE.DEFAULT
    );
    if (notDefaultLearningModes && notDefaultLearningModes.length > 0) {
      return true;
    }
  }
  return false;
}

/**
 * @typedef {import('Context/ClassroomContext/context').SectionGroup} SectionGroup
 * @typedef {import('Context/ClassroomContext/context').Section} Section
 * @typedef {import('Context/ClassroomContext/context').Subsection} Subsection
 * @typedef {import('Context/ClassroomContext/context').LearningMode} LearningMode
 */
